import React, { useEffect, useState } from 'react';
import './CaseDocumentUpload.page.css';
import DocumentUploadForm from '../../ui/panels/Forms/DocumentUploadForm';
import UserTokenData from '../../types/UserTokenData';
import { UserUtils } from '../../utils/UserUtils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { DocumentJobModel } from '../../types/DocumentJobModel';
import DocumentJobList from '../../ui/panels/DocumentJobList/DocumentJobList';
import LoadingSpinner from '../../ui/components/LoadingSpinner';
import { IoClose } from 'react-icons/io5';
import './CaseDocumentUpload.page.css';

// TODO this is essentialy a placeholder, proper CSS and styling need to be given, also need to add proper error indication

// TODO need to replace this with specific data not the whole thing
interface UserModel {
  userId: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  phone: string | null;
  email: string;
  dateAdded: string;
  dateUpdated: string | null;
  addedBy: string;
  updatedBy: string | null;
}

interface PatientState {
  patient: UserModel | null;
  error: string;
}

interface DocumentJobsState {
  documents: DocumentJobModel[];
  loading: boolean;
  error: string;
}

interface Props{
  token: string;
  nav: NavigateFunction;
  entityId: string;
  entityFirstName: string;
  entityLastName: string;
  onClose?: () => void;
}

function CaseDocumentUploadPage({token, nav, entityId, entityFirstName, entityLastName, onClose}:Props): JSX.Element {
  const entityIdNumber = Number(entityId);
  
  const [userDetails, setUserDetails] = useState<UserTokenData>({
    userName: '',
    id: '',
    email: '',
    role: '',
  });
  const [jobState, setJobState] = useState<DocumentJobsState>({
    documents: [],
    loading: false,
    error: '',
  });
  const [patientState, setPatientState] = useState<PatientState>({
    patient: null,
    error: '',
  });

  useEffect(() => {
    const decodedDetails = UserUtils.decodeUserToken(token);
    if (decodedDetails) {
      setUserDetails(decodedDetails);
    }
  }, [token]);

  const getPatient = async () => {
    const jsonData = { entityId: entityIdNumber };
    try {
      const response = await fetch('/case/patient', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(jsonData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('token');
          nav('/signin');
          return;
        }
        throw new Error('Failed to load jobs');
      }

      const json: UserModel = await response.json();
      setPatientState({
        patient: json,
        error: '',
      });
    } catch (error) {
      setPatientState((prev) => ({
        patient: prev.patient,
        error: `An error occurred when trying to request your Patient's data`,
      }));
    }
  };

  useEffect(() => {
    if (!patientState.patient) {
      getPatient();
    }
  }, []);

  const getDocumentJobs = async () => {
    setJobState((prev) => ({ ...prev, loading: true, error: '' }));
    const jsonData = { entityId: entityIdNumber };
    try {
      const response = await fetch('/case/upload/jobs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(jsonData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('token');
          nav('/signin');
          return;
        }
        throw new Error('Failed to load jobs');
      }

      const json: DocumentJobModel[] = await response.json();
      setJobState((prev) => ({ ...prev, documents: json, loading: false }));
    } catch (error) {
      setJobState((prev) => ({
        ...prev,
        loading: false,
        error: `An error occurred when trying to retrieve list of uploaded files`,
      }));
    }
  };

  useEffect(() => {
    getDocumentJobs();
  }, []);
  // Write function to load currently uploaded documents

  return (
    <div className="CaseDocUploadPage case-upload-page-overlay">
      <div className="CaseDocRow case-upload-page-container">
        <div className="case-upload-page-head">
          <h2>Upload Patient Document</h2>
          {onClose && (
            <button 
              onClick={onClose}>
              <IoClose className="case-upload-form-close"/>
            </button>
          )}
        </div>
        {userDetails.id == '' ? (
          <LoadingSpinner />
        ) : (
          <div className="case-upload-patient">
            <h4 className="case-upload-patient-heading">Patient Name:<span className="case-upload-patient-name">{' '}{entityFirstName} {entityLastName}</span></h4>
            <DocumentUploadForm
            token={token}
            userDetails={userDetails}
            entityId={entityIdNumber}
            nav={nav}
            onUploadSuccess={getDocumentJobs}
          />
          </div>
          
        )}
      </div>

        {/* TODO: Need to change backend and frontend to include multiple files for uploading */}
      {/* Row 2: Jobs list */}
      {/* <div className="CaseDocRow">
        <div className="CaseDocSectionHeader">Document Jobs</div>

        {jobState.loading && (
          <div className="CaseDocCenteredRow">
            <LoadingSpinner />
          </div>
        )}

        {!jobState.loading && jobState.error != '' && (
          <div className="CaseDocError">
            {`The following Error occurred: \n${jobState.error}\n please try again`}
          </div>
        )}

        {!jobState.loading && jobState.error == '' && (
          <DocumentJobList jobs={jobState.documents} />
        )}
      </div> */}
    </div>
  );
}

export default CaseDocumentUploadPage;
